import { render, staticRenderFns } from "./VideoAbsenceTicketInfo.vue?vue&type=template&id=352d9548"
import script from "./VideoAbsenceTicketInfo.vue?vue&type=script&lang=js"
export * from "./VideoAbsenceTicketInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports